<template>
  <main>
    <header class="header">
      <h1 class="header__title">21Days</h1>
    </header>
    <router-view></router-view>
    <footer class="footer">
      <nav>
        <ul class="footer__list">
          <li 
            @click="goTo('/')"
            class="footer__list-item">发现</li>
          <li 
            @click="createTask()"
            class="footer__list-item primary">创建</li>
          <li 
            @click="goTo('profile')"
            class="footer__list-item">我的</li>
        </ul>
      </nav>
    </footer>
  </main>
</template>

<script>
export default {
  methods: {
    goTo(route) {
      this.$router.push(route);
    },
    createTask() {
      this.$prompt('请输入挑战名称', '创建挑战', {
        confirmButtonText: '创建',
        cancelButtonText: '返回'
      }).then(({ value }) => {
        this.$message({ message: `${value} 挑战创建成功，快去邀请小伙伴一起来吧`, type: 'success' });
      }).catch(() => { /* it's ok to reject here */ });
    }
  }
};
</script>

<style>
body {
  font-family: -apple-system,"Helvetica Neue",Arial,"PingFang SC","Hiragino Sans GB",STHeiti,"Microsoft YaHei","Microsoft JhengHei","Source Han Sans SC","Noto Sans CJK SC","Source Han Sans CN","Noto Sans SC","Source Han Sans TC","Noto Sans CJK TC","WenQuanYi Micro Hei",SimSun,sans-serif;
  color: #fff;
  background-color: #382A66;
  margin: 0;
  padding: 0;
}

h1 {
  margin: 0;
}

ul {
  padding: 0;
  margin: 0;
}

.el-message-box {
  width: 80% !important;
}
</style>

<style scoped>
.header {
  text-align: center;
  padding: 30px 0;
}

.header__title {
  font-size: 1.2em;
  font-weight: 700;
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px;
  background-color: #19132E;
}

.footer__list {
  display: flex;
  list-style: none;  
  align-items: center;
  justify-content: space-around;
}

.footer__list-item {
  font-weight: 700;
  cursor: pointer;
  padding: 5px;
  border-radius: 5px;
  text-align: center;
  color: #ddd;
}

.footer__list-item.primary {
  background-color: #DA398C; 
}
</style>
